import {createContext} from "react";
import {CartItem, FloorPlanOption} from "../SharedTypes";

// The options is for ordering the cart items the same
export type CartItemAction = { type: 'AddItem', item: CartItem, options: FloorPlanOption[] }
    | { type: 'UpdateItem', item: CartItem, index: number }
    | { type: 'RemoveItem', index: number }
    | { type: 'LoadItems', items: CartItem[], options: FloorPlanOption[] }

export type CartContextType = { cartItems: CartItem[], dispatchCartItemAction: (action: CartItemAction) => void }

export const CartContext = createContext<CartContextType>({} as any);